<h3 name="subscriptionTitle1">{{'REGISTRATION.STEP.NETWORK_CHECK.FIRST_QUESTION' | translate}}</h3>
<form class="spacer-top-bottom" [formGroup]="form">
    <div class="top15 row">
        <div class="col-md-6 col-md-offset-2">
            <mat-form-field class="full-width spacer-bottom" required>
                <mat-label>{{'COMMON.USER_INFO.ADDRESS' | translate}}</mat-label>
                <app-address-autocomplete formControlName="primaryAddress" name="app-network-check-input"
                    (placeChanged)="placeChanged($event)" [ensureSelection]="true">
                </app-address-autocomplete>
                <mat-hint align="start"><strong>{{'REGISTRATION.STEP.NETWORK_CHECK.UNKNOWN_ADDRESS'|translate}} <a
                            href="tel:+33278340451">{{ '+33278340451' |phone}}</a></strong>
                </mat-hint>
                <mat-error> {{getPlaceErrors()}} </mat-error>
            </mat-form-field>
        </div>
        <div class="col-md-2">
            <button class="full-width color-btn min-btn-width" [disabled]="loading" mat-raised-button
                name="app-network-check-button" (click)="checkCoverage()">
                {{'REGISTRATION.STEP.NETWORK_CHECK.ACTION' | translate}}
            </button>
        </div>
    </div>
    <div *ngIf="loading">
        <app-loading></app-loading>
    </div>
    <div #scrollTo>
        <ng-container *ngIf="!virgin">
            <div class="row spacer-top-bottom">
                <div class="col-md-4 col-md-offset-2 text-center">
                    <h5>{{'REGISTRATION.STEP.NETWORK_CHECK.OUTDOOR_TITLE' | translate}}</h5>
                    <div style="height: 100px">
                        <img [src]="imgService.getCoverageState(outdoorFlag.class)" width="100">
                    </div>
                </div>
                <div class="col-md-4 text-center">
                    <h5>{{'REGISTRATION.STEP.NETWORK_CHECK.INDOOR_TITLE' | translate}}</h5>
                    <div style="height: 100px">
                        <img [src]="imgService.getCoverageState(indoorFlag.class)" width="100">
                    </div>
                </div>
            </div>
            <div class="additionalInfo">
                <div class="row">
                    <div class="col-md-10 col-md-offset-1 col-sm-12 network-check-description">
                        <p>
                            <b> {{'REGISTRATION.STEP.NETWORK_CHECK.OUTDOOR_TITLE' | translate}} </b> :
                            {{'REGISTRATION.STEP.NETWORK_CHECK.OUTDOOR_COVERAGE.' + outdoorFlag.class | translate}}
                        </p>
                        <p>
                            <b> {{'REGISTRATION.STEP.NETWORK_CHECK.INDOOR_TITLE' | translate}} </b> :
                            {{'REGISTRATION.STEP.NETWORK_CHECK.INDOOR_COVERAGE.' + indoorFlag.class | translate}}
                        </p>
                    </div>
                </div>
                <div class="in-doubt">
                    {{'REGISTRATION.STEP.NETWORK_CHECK.CONTACT_CUSTOMER_SERVICE' | translate: { phoneNumber:
                    ('REGISTRATION.CUSTOMER_SERVICE_NUMBER' | translate) } }}
                </div>
                <ng-container *ngIf="availableOptions.length > 0">
                    <mat-radio-group name="app-network-check-options" formControlName="option" class="row equal"
                        aria-label="Select an option">
                        <div class="col-md-3" *ngFor="let option of availableOptions">
                            <div class="option center" (click)="buttonClick(option.id)">
                                <h5>
                                    <ng-container *ngIf="option.name!=='none'">
                                        {{('REGISTRATION.STEP.NETWORK_CHECK.OPTIONS.'+option.type | translate)}}
                                    </ng-container>
                                    {{ 'REGISTRATION.STEP.NETWORK_CHECK.OPTIONS.'+option.name| translate}}
                                </h5>
                                <h4>
                                    <ng-container *ngIf="option.price>0;else free">
                                        {{ 'REGISTRATION.STEP.NETWORK_CHECK.OPTIONS.'+(option.type!=='purchase'
                                        ?'renting':'purchase')+'_price' | translate:{price:option.price} }}
                                    </ng-container>
                                    <ng-template #free>
                                        {{ 'COMMON.FREE' | translate }}
                                    </ng-template>
                                </h4>
                                <img class="option-img center-img" [src]="imgService.getEquipment(option.name)">
                                <mat-radio-button class="spacer-top" [value]="option.id">
                                </mat-radio-button>
                            </div>
                        </div>
                        <mat-error *ngIf="form.get('option').touched && form.get('option').invalid" class="center">
                            {{'VALIDATION.PICK_CHOICE'|translate}}
                        </mat-error>
                    </mat-radio-group>
                    <p class="text-center top30">
                        {{'REGISTRATION.STEP.NETWORK_CHECK.TAX' | translate }}
                    </p>
                    <div *ngIf="tip" class="spacer-top">
                        <p>
                            {{'REGISTRATION.STEP.NETWORK_CHECK.TIPS.'+tip | translate}}
                            <a [href]="'REGISTRATION.STEP.NETWORK_CHECK.LINK.'+tip | translate"
                                target="_blank">{{'REGISTRATION.STEP.NETWORK_CHECK.LINK_TITLE' | translate}}</a>
                        </p>
                    </div>
                </ng-container>
            </div>
            <div class="row">
                <div class="col-md-12 controls-button">
                    <button mat-raised-button color="primary" name="goNext1" class="pull-right" (click)="continue()">
                        {{'COMMON.CONTINUE' | translate}}
                    </button>
                </div>
            </div>
        </ng-container>
    </div>
</form>